// extracted by mini-css-extract-plugin
export default {"filterArrow":"FilterWindow_filterArrow__Ywq7V","hideArrow":"FilterWindow_hideArrow__-eC8n","placeHolderShimmer":"FilterWindow_placeHolderShimmer__NbZlb"};